"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnvironmentTypes = exports.SubscriptionTypes = exports.PrinterTypes = void 0;
var PrinterTypes;
(function (PrinterTypes) {
    PrinterTypes["DEFAULT"] = "";
    PrinterTypes["THREE_INCH"] = "3inch";
    PrinterTypes["TWO_INCH"] = "2inch";
})(PrinterTypes || (exports.PrinterTypes = PrinterTypes = {}));
var SubscriptionTypes;
(function (SubscriptionTypes) {
    SubscriptionTypes[SubscriptionTypes["TEST"] = -1] = "TEST";
    SubscriptionTypes[SubscriptionTypes["UNKNOWN"] = 0] = "UNKNOWN";
    SubscriptionTypes[SubscriptionTypes["PRODUCTION"] = 1] = "PRODUCTION";
    SubscriptionTypes[SubscriptionTypes["CLOVER_DEMO"] = 2] = "CLOVER_DEMO";
    SubscriptionTypes[SubscriptionTypes["CLOVER_UNKNOWN"] = 4] = "CLOVER_UNKNOWN";
    SubscriptionTypes[SubscriptionTypes["CLOVER_FREE_TIER"] = 5] = "CLOVER_FREE_TIER";
    SubscriptionTypes[SubscriptionTypes["CLOVER_PRO_TIER"] = 6] = "CLOVER_PRO_TIER";
    SubscriptionTypes[SubscriptionTypes["CLOVER_TRIAL"] = 7] = "CLOVER_TRIAL";
    SubscriptionTypes[SubscriptionTypes["CLOVER_UNINSTALLED"] = 9] = "CLOVER_UNINSTALLED";
    SubscriptionTypes[SubscriptionTypes["DEACTIVATED"] = 12] = "DEACTIVATED";
    SubscriptionTypes[SubscriptionTypes["PRODUCTION_UNPAID"] = 13] = "PRODUCTION_UNPAID";
    SubscriptionTypes[SubscriptionTypes["BLOCKED_UNPAID"] = 14] = "BLOCKED_UNPAID";
    SubscriptionTypes[SubscriptionTypes["STRIPE"] = 17] = "STRIPE";
    SubscriptionTypes[SubscriptionTypes["ONE_TO_MANY"] = 19] = "ONE_TO_MANY";
})(SubscriptionTypes || (exports.SubscriptionTypes = SubscriptionTypes = {}));
var EnvironmentTypes;
(function (EnvironmentTypes) {
    EnvironmentTypes[EnvironmentTypes["Production"] = 0] = "Production";
    EnvironmentTypes[EnvironmentTypes["Test"] = 1] = "Test";
    EnvironmentTypes[EnvironmentTypes["Internal"] = 2] = "Internal";
    EnvironmentTypes[EnvironmentTypes["Carrier"] = 3] = "Carrier";
    EnvironmentTypes[EnvironmentTypes["Template"] = 4] = "Template";
})(EnvironmentTypes || (exports.EnvironmentTypes = EnvironmentTypes = {}));
//# sourceMappingURL=merchant.js.map